<script setup lang="ts">
import { RouterLink } from 'vue-router';

/**
 * 指标卡。
 *
 * 传了 `to` 就整张卡可点，落到已经带好筛选的项目列表；不传还是纯展示。
 * 指挥台上这四个数字原来全是死的——看到「待补计划 2」却没办法知道是哪两个，
 * 只能自己去项目列表里翻。
 */
defineProps<{
  index: string;
  label: string;
  value: number | string;
  note: string;
  tone?: 'risk' | 'warning' | 'normal';
  to?: string;
  /** 点进去看到的是什么；「28 条逾期里程碑」点开是 9 个项目，不说清楚会以为数错了 */
  linkHint?: string;
}>();
</script>

<template>
  <component
    :is="to ? RouterLink : 'article'"
    :to="to"
    class="metric-card"
    :class="[tone ? `is-${tone}` : '', { 'is-linked': to }]"
    :aria-label="to ? `${label} ${value}，${linkHint || '查看明细'}` : undefined"
  >
    <b>{{ index }}</b>
    <span>{{ label }}</span>
    <strong>{{ value }}</strong>
    <small>{{ note }}</small>
    <em v-if="to" class="metric-link-hint">{{ linkHint || '查看明细' }} →</em>
  </component>
</template>

<style scoped>
.metric-card.is-linked {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: border-color .12s, box-shadow .12s;
}

.metric-card.is-linked:hover,
.metric-card.is-linked:focus-visible {
  border-color: var(--blue);
  box-shadow: 0 2px 12px rgba(16, 39, 56, .1);
}

.metric-link-hint {
  display: block;
  margin-top: 6px;
  color: var(--blue);
  font-size: 12px;
  font-style: normal;
}

.metric-card.is-risk .metric-link-hint { color: var(--risk); }
.metric-card.is-warning .metric-link-hint { color: var(--warning); }
</style>
